'use strict';

// data-src="hier de image url opgeven"
// data-algin="" 3 opties:
// Y: top middle bottom, default: middle,
// X: top center right, default: center,
// scale,
// y en x kan je combineren.
// scale heeft als extra optie data-offset
// data-loader="", true of false
// data-offset="" aantal pixels, als align = scale;
var $;

$.fn.imageLoader = function (options) {

	options = $.extend({
		loader: '<span class="loader icon"></span>',
		ready: function ready(prop, align) {},
		resize: function resize(prop, align) {}
	}, options);

	var $items = $(this);

	function isIE() {
		var IE = navigator.userAgent.toLowerCase().indexOf('trident') > -1;
		if (IE == true) {
			var ua = window.navigator.userAgent;
			var msie = ua.indexOf("MSIE ");
			if (navigator.userAgent.match(/Trident.*rv\:11\./)) {
				return 11;
			} else {
				msie = parseInt(ua.substring(msie + 5, ua.indexOf(".", msie)));
				return msie;
			}
		} else {
			return false;
		}
	}

	function getBool(val) {
		if (val.toLowerCase() == 'false') {
			return false;
		} else {
			return true;
		}
	}

	function getProps($this) {
		return {
			$img: $this,
			$parent: $this.parent(),
			$loader: false,
			src: $this.attr('data-src'),
			align: typeof $this.attr('data-align') === 'undefined' ? 'none' : $this.attr('data-align'),
			loader: typeof $this.attr('data-loader') === 'undefined' ? true : getBool($this.attr('data-loader')),
			offset: typeof $this.attr('data-offset') === 'undefined' ? 0 : parseInt($this.attr('data-offset')),
			orgine: {
				width: null,
				height: null
			}
		};
	}

	function errors(prop, callback) {
		if (typeof prop.src !== 'undefined') {
			callback(prop);
		} else {
			//console.log(prop);
		}
	}

	function loader(prop, callback) {
		if (prop.loader == false) {
			callback(prop);
		} else {
			prop.$parent.prepend(options.loader);
			prop.$loader = prop.$parent.find('.loader');
			setTimeout(function () {
				prop.$loader.addClass('active');
			}, 10);
			callback(prop);
		}
	}

	function loadImg(prop, callback) {
		prop.$img.show();
		prop.$img.attr('src', prop.src);
		var IE = isIE();
		if (IE != false && IE <= 8) {
			callback(prop);
		} else {
			prop.$img.on('load', function () {
				callback(prop);
			});
		}
	}

	function getAlign(prop) {
		if (prop.align == false) {
			align = false;
		} else {
			if (prop.orgine.width == null) {
				prop.orgine.width = prop.$img.width();
				prop.orgine.height = prop.$img.height();
			}
			var container = {
				width: prop.$parent.width(),
				height: prop.$parent.height()
			},
			    align = {
				width: 0,
				height: 0,
				left: 0,
				top: 0,
				x: false,
				y: false
			},
			    scale = false,
			    higher = true,
			    procent;
			prop.align = prop.align.toLowerCase();
			if (prop.align != 'scale') {
				align.width = container.width;
				procent = container.width / prop.orgine.width;
				align.height = Math.round(prop.orgine.height * procent);
				if (align.height < container.height) {
					higher = false;
					align.height = container.height;
					procent = container.height / prop.orgine.height;
					align.width = Math.round(prop.orgine.width * procent);
				}
				if (prop.align != 'none') {
					switch (true) {
						case prop.align.indexOf('top') >= 0:
							align.y = 'top';
							break;
						case prop.align.indexOf('middle') >= 0:
							align.y = 'middle';
							break;
						case prop.align.indexOf('bottom') >= 0:
							align.y = 'bottom';
							break;
						default:
							align.y = 'middle';
							break;
					}
					switch (true) {
						case prop.align.indexOf('left') >= 0:
							align.x = 'left';
							break;
						case prop.align.indexOf('center') >= 0:
							align.x = 'center';
							break;
						case prop.align.indexOf('right') >= 0:
							align.x = 'right';
							break;
						default:
							align.x = 'center';
							break;
					}
					switch (align.y) {
						case 'top':
							align.top = 0;
							break;
						case 'middle':
							if (higher == true) {
								align.top = (container.height - align.height) / 2;
							} else {
								align.top = 0;
							}
							break;
						case 'bottom':
							if (higher == true) {
								align.top = container.height - align.height;
							} else {
								align.top = 0;
							}
							break;
					}
					switch (align.x) {
						case 'left':
							align.left = 0;
							break;
						case 'center':
							if (higher == false) {
								align.left = (container.width - align.width) / 2;
							} else {
								align.left = 0;
							}
							break;
						case 'right':
							if (higher == false) {
								align.left = container.width - align.width;
							} else {
								align.left = 0;
							}
							break;
					}
				} else {
					align = false;
				}
			} else {
				if (prop.offset != false) {
					container.height = container.height - 2 * prop.offset;
					container.width = container.width - 2 * prop.offset;
				}
				align.width = container.width;
				procent = container.width / prop.orgine.width;
				align.height = Math.round(prop.orgine.height * procent);
				if (align.height > container.height) {
					align.height = container.height;
					procent = container.height / prop.orgine.height;
					align.width = Math.round(prop.orgine.width * procent);
				}
				align.top = (container.height - align.height) / 2 + prop.offset;
				align.left = (container.width - align.width) / 2 + prop.offset;
			}
			return align;
		}
	}

	function show(prop, align, callback) {
		prop.$img.css({ 'width': align.width, 'height': align.height, 'top': align.top, 'left': align.left });
		prop.$img.addClass('active');
		if (prop.$loader != false) {
			prop.$loader.removeClass('active');
			setTimeout(function () {
				prop.$loader.remove();
			}, 500);
		}
		callback(prop);
	}

	$.fn.imageLoader.resize = function () {
		$items.each(function () {
			var $this = $(this).is("img") ? $(this) : $(this).find('img'),
			    prop = getProps($this),
			    align = getAlign(prop);
			prop.$img.css({ 'width': align.width, 'height': align.height, 'top': align.top, 'left': align.left });
		});
	};

	this.init = function () {
		//delete $items;
		this.each(function () {
			var $this = $(this).is("img") ? $(this) : $(this).find('img'),
			    prop = getProps($this);
			errors(prop, function (prop) {
				loader(prop, function (prop) {
					loadImg(prop, function (prop) {
						var align = getAlign(prop);
						show(prop, align, function (prop) {
							$.isFunction(options.ready) && options.ready.call(this, prop, align);
						});
					});
				});
			});
		});
	};
	this.init();
};